export default function handleClickOutside(element, event) {
  const e = window.event || event

  let el = eventTarget(e)
  while (el !== null) {
    if (el === element) {
      return false
    }
    el = el.parentNode
  }
  return true
}

function eventTarget(event) {
  let targ = event.target ? event.target : event.srcElement
  if (targ !== null) {
    if (targ.nodeType === 3) {
      targ = targ.parentNode
    }
  }
  return targ
}



// WEBPACK FOOTER //
// ../src/components/Tether/utils/isClickOutside.js